import { CoreApi, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import { selectedEntityIsNotClothRail } from 'rangeConfig/aurdal/rules/hideMenuRules';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import {
  matchDepth,
  matchDesign,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';

const productCardWidget = {
  id: 'frames-selected-menu-frames',
  behaviors: {},
  noThumbs: () => true,
  productFilters: [matchDesign],
  hidden: selectedEntityIsNotClothRail
};

const interiors = {
  id: 'section-selected-menu-interiors',
  title: 'storageone.productListInteriorsTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addToTarget],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.AURDAL_SHELF,
    ProductType.AURDAL_DRAWER,
    ProductType.AURDAL_BASKET,
    ProductType.AURDAL_SHOERACK,
    ProductType.AURDAL_CLOTH_RAIL
  ],
  productFilters: [matchWidth, matchDepth]
};

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    interiors,
    productCardWidget
  ],
  mobile: [interiors]
};

const selectedMenu: SelectedMenu = {
  menuTitle: (coreApi: CoreApi) =>
    coreApi.entities
      .findSelectedEntity()
      ?.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType ===
    ProductType.AURDAL_EXT_CLOTH_RAIL
      ? 'storageone.extendableClothRailTitle'
      : 'storageone.productListSectionsTitle',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
